
/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  AdminInformationResponse,
  AdvancedSearchAdminAlgorithmsResultsResponse,
  AdvancedSearchResponse,
  BenchmarkStartResponse,
  ComputeOpportunityScoreRequest,
  ComputeOpportunityScoreResponse,
  EntityType,
} from '../models';
import {
    AdminInformationResponseFromJSON,
    AdminInformationResponseToJSON,
    AdvancedSearchAdminAlgorithmsResultsResponseFromJSON,
    AdvancedSearchAdminAlgorithmsResultsResponseToJSON,
    AdvancedSearchResponseFromJSON,
    AdvancedSearchResponseToJSON,
    BenchmarkStartResponseFromJSON,
    BenchmarkStartResponseToJSON,
    ComputeOpportunityScoreRequestFromJSON,
    ComputeOpportunityScoreRequestToJSON,
    ComputeOpportunityScoreResponseFromJSON,
    ComputeOpportunityScoreResponseToJSON,
    EntityTypeFromJSON,
    EntityTypeToJSON,
} from '../models';

export interface CompareMatchingSystemsRequest {
    advancedSearchId: string;
}

export interface ComputeOpportunityScoreOperationRequest {
    computeOpportunityScoreRequest: ComputeOpportunityScoreRequest;
}

export interface DownloadBenchmarkTemplateRequest {
    path: string;
}

export interface FindAdvancedSearchByIdRequest {
    advancedSearchId: string;
}

export interface ForceSwitchCompletionForEntityRequest {
    entity: EntityType;
    lang?: string;
}

export interface GetBenchmarkStatusRequest {
    sessionId: string;
}

export interface ReindexEntityRequest {
    entity: EntityType;
    lang?: string;
}

export interface ReindexEntityIdRequest {
    entity: EntityType;
    entityId: string;
}

export interface RunBenchmarkFromResourceRequest {
    path: string;
}

export interface RunBenchmarkFromUploadRequest {
    file: Blob;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Executes algorithms for a given advanced search to be able to compare results
          */
    async compareMatchingSystemsRaw(requestParameters: CompareMatchingSystemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchAdminAlgorithmsResultsResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling compareMatchingSystems().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearchAdminAlgorithmsResultsResponse>({
            path: `/search/admin/advanced/{advancedSearchId}/compare-matching-systems`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchAdminAlgorithmsResultsResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Executes algorithms for a given advanced search to be able to compare results
          */
    async compareMatchingSystems(requestParameters: CompareMatchingSystemsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchAdminAlgorithmsResultsResponse> {
        const response = await this.compareMatchingSystemsRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Compute opportunity quality score for several advanced searches (admin can force recompute of already submitted ones)
          */
    async computeOpportunityScoreRaw(requestParameters: ComputeOpportunityScoreOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ComputeOpportunityScoreResponse>> {
        if (requestParameters['computeOpportunityScoreRequest'] == null) {
            throw new runtime.RequiredError(
                'computeOpportunityScoreRequest',
                'Required parameter "computeOpportunityScoreRequest" was null or undefined when calling computeOpportunityScore().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<ComputeOpportunityScoreResponse>({
            path: `/search/admin/advanced/opportunity-score`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ComputeOpportunityScoreRequestToJSON(requestParameters['computeOpportunityScoreRequest']),
        }, initOverrides);

        if (response._data) { response._data=ComputeOpportunityScoreResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Compute opportunity quality score for several advanced searches (admin can force recompute of already submitted ones)
          */
    async computeOpportunityScore(requestParameters: ComputeOpportunityScoreOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ComputeOpportunityScoreResponse> {
        const response = await this.computeOpportunityScoreRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Download a benchmark template CSV file
          */
    async downloadBenchmarkTemplateRaw(requestParameters: DownloadBenchmarkTemplateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Blob>> {
        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling downloadBenchmarkTemplate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Blob>({
            path: `/search/admin/api/opportunity-score-benchmark/resources/download`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Download a benchmark template CSV file
          */
    async downloadBenchmarkTemplate(requestParameters: DownloadBenchmarkTemplateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.downloadBenchmarkTemplateRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Find advanced search by id
          */
    async findAdvancedSearchByIdRaw(requestParameters: FindAdvancedSearchByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdvancedSearchResponse>> {
        if (requestParameters['advancedSearchId'] == null) {
            throw new runtime.RequiredError(
                'advancedSearchId',
                'Required parameter "advancedSearchId" was null or undefined when calling findAdvancedSearchById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdvancedSearchResponse>({
            path: `/search/admin/advanced/{advancedSearchId}`.replace(`{${"advancedSearchId"}}`, encodeURIComponent(String(requestParameters['advancedSearchId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdvancedSearchResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Find advanced search by id
          */
    async findAdvancedSearchById(requestParameters: FindAdvancedSearchByIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdvancedSearchResponse> {
        const response = await this.findAdvancedSearchByIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Force Switch Completion for the given Entity
          */
    async forceSwitchCompletionForEntityRaw(requestParameters: ForceSwitchCompletionForEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['entity'] == null) {
            throw new runtime.RequiredError(
                'entity',
                'Required parameter "entity" was null or undefined when calling forceSwitchCompletionForEntity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/admin/indices/{entity}/force-switch-completion`.replace(`{${"entity"}}`, encodeURIComponent(String(requestParameters['entity']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Force Switch Completion for the given Entity
          */
    async forceSwitchCompletionForEntity(requestParameters: ForceSwitchCompletionForEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.forceSwitchCompletionForEntityRaw(requestParameters, initOverrides);
    }

    /**
     * Get All Search Administration information
          */
    async getAdminInformationRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<AdminInformationResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<AdminInformationResponse>({
            path: `/search/admin`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=AdminInformationResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get All Search Administration information
          */
    async getAdminInformation(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<AdminInformationResponse> {
        const response = await this.getAdminInformationRaw(initOverrides);
        return response._data;
    }

    /**
     * Get benchmark status. Use for initial data and recovery
          */
    async getBenchmarkStatusRaw(requestParameters: GetBenchmarkStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<{ [key: string]: any; }>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getBenchmarkStatus().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<{ [key: string]: any; }>({
            path: `/search/admin/api/opportunity-score-benchmark/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Get benchmark status. Use for initial data and recovery
          */
    async getBenchmarkStatus(requestParameters: GetBenchmarkStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getBenchmarkStatusRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * List available benchmark CSV resources
          */
    async listBenchmarkResourcesRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<string>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<string>>({
            path: `/search/admin/api/opportunity-score-benchmark/resources`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * List available benchmark CSV resources
          */
    async listBenchmarkResources(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.listBenchmarkResourcesRaw(initOverrides);
        return response._data;
    }

    /**
     * Reindex entity
          */
    async reindexEntityRaw(requestParameters: ReindexEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['entity'] == null) {
            throw new runtime.RequiredError(
                'entity',
                'Required parameter "entity" was null or undefined when calling reindexEntity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['lang'] != null) {
            queryParameters['lang'] = requestParameters['lang'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/admin/indices/{entity}/reindex`.replace(`{${"entity"}}`, encodeURIComponent(String(requestParameters['entity']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex entity
          */
    async reindexEntity(requestParameters: ReindexEntityRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexEntityRaw(requestParameters, initOverrides);
    }

    /**
     * Reindex only one entityId
          */
    async reindexEntityIdRaw(requestParameters: ReindexEntityIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['entity'] == null) {
            throw new runtime.RequiredError(
                'entity',
                'Required parameter "entity" was null or undefined when calling reindexEntityId().'
            );
        }

        if (requestParameters['entityId'] == null) {
            throw new runtime.RequiredError(
                'entityId',
                'Required parameter "entityId" was null or undefined when calling reindexEntityId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<void>({
            path: `/search/admin/indices/{entity}/{entityId}/reindex`.replace(`{${"entity"}}`, encodeURIComponent(String(requestParameters['entity']))).replace(`{${"entityId"}}`, encodeURIComponent(String(requestParameters['entityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return response;
    }

    /**
     * Reindex only one entityId
          */
    async reindexEntityId(requestParameters: ReindexEntityIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.reindexEntityIdRaw(requestParameters, initOverrides);
    }

    /**
     * Start benchmark from resource CSV file
          */
    async runBenchmarkFromResourceRaw(requestParameters: RunBenchmarkFromResourceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BenchmarkStartResponse>> {
        if (requestParameters['path'] == null) {
            throw new runtime.RequiredError(
                'path',
                'Required parameter "path" was null or undefined when calling runBenchmarkFromResource().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['path'] != null) {
            queryParameters['path'] = requestParameters['path'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BenchmarkStartResponse>({
            path: `/search/admin/api/opportunity-score-benchmark/run/resource`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BenchmarkStartResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Start benchmark from resource CSV file
          */
    async runBenchmarkFromResource(requestParameters: RunBenchmarkFromResourceRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BenchmarkStartResponse> {
        const response = await this.runBenchmarkFromResourceRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Start benchmark from uploaded CSV file
          */
    async runBenchmarkFromUploadRaw(requestParameters: RunBenchmarkFromUploadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BenchmarkStartResponse>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling runBenchmarkFromUpload().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<BenchmarkStartResponse>({
            path: `/search/admin/api/opportunity-score-benchmark/run/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=BenchmarkStartResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Start benchmark from uploaded CSV file
          */
    async runBenchmarkFromUpload(requestParameters: RunBenchmarkFromUploadRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BenchmarkStartResponse> {
        const response = await this.runBenchmarkFromUploadRaw(requestParameters, initOverrides);
        return response._data;
    }

}
